<script setup>
// import { ref, computed } from 'vue'
// import { useRouter } from 'vue-router'
// const router = useRouter()
</script>

<template>
  <section class="l-page">
    <div class="l-page__wrapper">
      <div class="c-compBox">
        <div class="c-compBox__media">
          <i class="icon-mailaddress" />
        </div>
        <p>新しいメールアドレスに変更されました。</p>
      </div>
      <RouterLink
        :to="{name:'AshibetuTop'}"
        class="c-button c-button--medium c-button--black"
      >
        トップページ
      </RouterLink>
    </div>
  </section>
</template>

<style scoped lang="scss">

</style>
